module.exports = global["jQuery"] = require("-!E:\\2_BuildAgent\\_work\\222\\s\\XL-R333-wwwhsn\\Frontend\\Hsn.Web.Site\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js-exposed
// module id = l/Rs
// module chunks = 24